// forked and modified from 'https://www.npmjs.com/package/is-empty-object'

export const isEmptyObject = (obj): boolean => {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return false
  return !Object.keys(obj).length
}